import {Component, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NgxSpinnerService} from 'ngx-spinner';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var $: any;

@Component({
  selector: 'app-solicitudes',
  templateUrl: './solicitudes.component.html',
  styleUrls: ['./solicitudes.component.css'],
  providers: [UserService]
})
export class SolicitudesComponent implements OnInit {
  public identity;
  public solicitudes: any = [];
  public solicitudes_codeudor: any = [];
  public disabled_solicitudes;
  public url_solicitud;
  public url_codeudores;
  public url_actualizacion;
  public tipoFirma = 'Deudor';
  datosSolicitudCreditoToken: any = '';
  numPagaredeceval: any = '';
  condicionesLineaCredito;
  exitoFirma = true;
  closeResult = '';
  showFormSolicitudes = false;
  sectionActive = 'one';
  public config

  formularioDatosPersonales: any = {};
  formularioDatosCredito: FormGroup;
  formularioCodeudores: FormGroup;
  formularioAdjuntos: FormGroup;
  formularioAutorizaciones: FormGroup;
  formularioDirecciones: any = {
    nombreVia: '',
    numeroVia: '',
    numeroViaSecundaria: '',
    numeroCasa: '',
    complementos: '',
    cualComplemento: ''
  };
  items: FormArray;

  stepActive = {
    one: 'active',
    two: '',
    three: '',
    four: '',
    five: '',
    six: ''
  };

  labelsFormulario = {
    titulo: 'DATOS PERSONALES'
  };

  createFormGroup = {
    token: ''
  };

  respuesta = {
    message: '',
    form: '',
    status: ''
  };

  departamentos;
  ciudades;
  bancos;
  entidades;
  vinculos;
  cargos;

  nombAsociado;
  apllAsociado;

  desabilitarbtn = false;
  btnSalir = false;
  lineasCredito;
  plazos;
  tcodeudores = false;
  destinos;
  frecuencias;
  autorizaciones;
  mdlSampleIsOpen = false;
  mdlCondicionesIsOpen = false;
  mdlDireccionesIsOpen = false;
  creditos: any = [];
  checkCreditos: any = [];
  totalSaldoRecoge: any = 0;
  mensajeErrorMontoRecoge: any = {};
  pagaresRecoger = [];
  datosCreditos = [];
  opcDireccion;
  adjuntosSolicitud;

  formularioToken = false;
  formularioTokenPrincipal = false;
  tokenEnviado = false;
  alert = {
    type: 'success',
    dismissible: true,
    msg: null,
    timeout: 35000
  };
  nombresDeudor;
  historialSolicitud: any = [];
  entidadActual = environment.actual;
  aplicaActualizaDatos = environment.entidad[this.entidadActual].activaActualizacionDatos;
  entidadNombreCompleto = environment.entidad[this.entidadActual].nombreFondoCompleto;
  entidadNombre = environment.entidad[this.entidadActual].entidadNombre;
  nombreCompletoEntidad = environment.entidad[this.entidadActual].nombreFondoCompleto;

  constructor(
    private _userService: UserService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
  ) {

  }

  async ngOnInit() {
    this.identity = await JSON.parse(this._userService.GetsessionStorage('identity'));
    this.config = JSON.parse(this._userService.GetsessionStorage('config'));
    this.nombAsociado = this.identity.NOMBRES;
    this.apllAsociado = this.identity.APELLIDOS;
    this.buildForm();
    this.comprobrarSolicitudes();
    this.listarSolicitudesCodeudor();
  }

  swichFirmaPagare(value) {
    this.formularioToken = value;
    this.tokenEnviado = value;
  }

  openModalRecogeCredN(content) {
    console.log('creditos', this.creditos);
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'xl'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      /*this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;*/
    });
  }

  open(content, credito, nombres) {
    this.nombresDeudor = nombres;
    this._userService.httpGet('validarActualizacion/'+this.identity.CODASOCIADO).subscribe(resp => {
      this.spinner.hide();
      console.log(this.aplicaActualizaDatos);
      console.log(resp.ACTUALIZA);
      if ((resp.ACTUALIZA === 1 || resp.ACTUALIZA === '1') && this.aplicaActualizaDatos) {
        alert('Para aceptar o negar la solicitud es necesario actualizar tus datos');
        this.router.navigateByUrl('actualizacion');
      } else {
        this.datosSolicitudCreditoToken = credito;
        this.modalService.open(content,
          {backdropClass: 'light-blue-backdrop', size: 'lg', windowClass: 'dark-modal', centered: true, backdrop: 'static', keyboard: false}
        ).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          console.log(reason);
        });
      }

      /*if (resp.ACTUALIZA === 0) {
        this.datosSolicitudCreditoToken = credito;
        this.modalService.open(content,
          { backdropClass: 'light-blue-backdrop', size: 'lg', windowClass: 'dark-modal', centered: true, backdrop: 'static', keyboard: false}
          ).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          console.log(reason);
        });
      } else  {
        alert('Para aceptar o negar la solicitud es necesario actualizar tus datos');
        this.router.navigateByUrl('actualizacion');
      }*/
    }, error => {
      this.spinner.show();
      console.log(error);
    });

  }

  close(value) {
    this.spinner.show();
    let acepta;
    if (value) {
      acepta = 'A';
    } else {
      acepta = 'R';
    }
    const data = {
      numsol: this.datosSolicitudCreditoToken.NUMSOL,
      codasociado: this.identity.CODASOCIADO,
      acepta
    };
    this._userService.httpPost('aceptaSolicitud', data).subscribe(resp => {
      this.spinner.hide();
      this.listarSolicitudesCodeudor();
      alert(resp.message);
    }, error => {
      alert(error.message);
    });
  }

  getParamsAdjuntos() {
    this._userService.httpGet('parametrosAdjuntos').subscribe(resp => {
      this.adjuntosSolicitud = resp.details;
      if (resp.details.cantidadRequeridos === '1') {
        this.formularioAdjuntos.get('ADJUNTO1').setValidators([Validators.required]);
      } else if (resp.details.cantidadRequeridos === '2') {
        this.formularioAdjuntos.get('ADJUNTO1').setValidators([Validators.required]);
        this.formularioAdjuntos.get('ADJUNTO2').setValidators([Validators.required]);
      }
    }, error => {
      console.log(error);
    });
  }

  getTrackingSolicitud(content, numsol) {
    this._userService.httpGet('trackingSolicitud/'+numsol).subscribe(resp => {
      this.historialSolicitud = resp.details;
      this.modalService.open(content,
        {backdropClass: 'light-blue-backdrop', size: 'xl', windowClass: 'dark-modal', centered: true, backdrop: 'static', keyboard: false}
      ).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        console.log(reason);
      });
    }, error => {

    });
  }

  crearDireccion(form) {
    if (form.invalid) {
      alert('Para continuar es necesario completar los campos requeridos');
      this.markFormGroupTouched(form);
    } else {
      let direccion;
      if (this.formularioDirecciones.complementos && this.formularioDirecciones.cualComplemento) {
        direccion = this.formularioDirecciones.nombreVia + ' ' + this.formularioDirecciones.numeroVia + ' ' + this.formularioDirecciones.numeroViaSecundaria + ' ' + this.formularioDirecciones.complementos + ' ' + this.formularioDirecciones.cualComplemento;
      } else {
        direccion = this.formularioDirecciones.nombreVia + ' ' + this.formularioDirecciones.numeroVia + ' ' + this.formularioDirecciones.numeroViaSecundaria;
      }

      switch (this.opcDireccion) {
        case 1:
          this.formularioDatosCredito.get('DIRECCIONREFFAMILIAR1').setValue(direccion);
          break;
        case 2:
          this.formularioDatosCredito.get('DIRECCIONREFFAMILIAR2').setValue(direccion);
          break;
        case 3:
          this.formularioDatosCredito.get('DIRECCIONREFPERSONAL1').setValue(direccion);
          break;
        case 4:
          this.formularioDatosCredito.get('DIRECCIONREFPERSONAL2').setValue(direccion);
          break;
      }
      form.reset();
      this.openModalDirecciones(false, this.opcDireccion);
    }

  }

  openModalCondiciones(value) {
    this.mdlCondicionesIsOpen = value;
  }

  openModalDirecciones(value, opc) {
    this.opcDireccion = opc;
    this.mdlDireccionesIsOpen = value;
  }

  agregarCreditosSeleccionados() {
    if (this.pagaresRecoger.length) {
      this.formularioDatosCredito.get('NUMCREDRECOGE').setValue(this.pagaresRecoger);
      this.formularioDatosCredito.get('DATOSCREDITORECOGE').setValue(this.datosCreditos);
      this.modalService.dismissAll();
      this.MONTO.disable();
    } else {
      this.formularioDatosCredito.get('NUMCREDRECOGE').setValue('');
      this.mensajeErrorMontoRecoge.message = 'No has seleccionado ningún crédito';
      $('#topElement').fadeIn(1000);
      $('#bottomElement').fadeIn(1000);
      setTimeout( () => {
        $('#topElement').fadeOut(5000);
        $('#bottomElement').fadeOut(5000);
      }, 6000);
    }
  }

  seleccionarCreditosRecoger(event, pagare, credito) {
    const valor = event.target.value;
    const montoCredito = this.formularioDatosCredito.get('MONTO').value;
    if (event.target.checked) {
      this.pagaresRecoger.push(pagare);
      this.datosCreditos.push(credito);
      this.totalSaldoRecoge += parseInt(valor);
      if (this.totalSaldoRecoge > montoCredito) {
        this.removeItemFromArr(this.pagaresRecoger, pagare);
        this.removeItemFromArr(this.datosCreditos, credito);
        this.totalSaldoRecoge -= parseInt(valor);
        this.mensajeErrorMontoRecoge.message = 'El valor de los créditos seleccionados es mayor al valor solicitado';
        $('#topElement').fadeIn(1000);
        $('#bottomElement').fadeIn(1000);
        setTimeout(function() {
          $('#topElement').fadeOut(5000);
          $('#bottomElement').fadeOut(5000);
        }, 6000);
        event.target.checked = false;
      }
    } else {
      this.removeItemFromArr(this.pagaresRecoger, pagare);
      this.removeItemFromArr(this.datosCreditos, credito);
      this.totalSaldoRecoge -= parseInt(valor);
    }

  }

  removeItemFromArr(arr, item) {
    const i = arr.indexOf(item);
    if (i !== -1) {
      arr.splice(i, 1);
    }
  }

  cancelarModalRecogeCred() {
    this.totalSaldoRecoge = 0;
    this.formularioDatosCredito.get('NUMCREDRECOGE').setValue('');
    this.formularioDatosCredito.get('RECOGECRED').setValue(null);
    this.pagaresRecoger = [];
    this.datosCreditos = [];
  }

  openModalRecogeCred(content, event): void {
    if (event.target.value === 'S') {
      const date = new Date();
      const day = date.getDate();
      const monthIndex = date.getMonth();
      const year = date.getFullYear();
      const data = {
        codasociado: this.identity.CODASOCIADO,
        fhasta: year + '-' + (monthIndex + 1) + '-' + day,
        recoge: true,
        pse: false
      };
      this._userService.httpPost('cartera', data).subscribe(resp => {
        this.creditos = resp;
        for (let i = 0; i < this.creditos.length - 1; i++) {
          const chk = 'chk' + i;
          this.checkCreditos.push({chk: i});
        }
      }, error => {
        console.log(JSON.parse(error));
      });
      this.modalService.open(content, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'xl',
        scrollable: true,
        keyboard: false,
        backdrop: 'static'
      }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        /*this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;*/
        //this.formularioDatosCredito.get('RECOGECRED').setValue('');
      });
    } else {
      this.totalSaldoRecoge = 0;
      this.pagaresRecoger = [];
      this.datosCreditos = [];
      this.formularioDatosCredito.get('NUMCREDRECOGE').setValue('');
      this.formularioDatosCredito.get('DATOSCREDITORECOGE').setValue(null);
    }


  }

  showFormToken(value) {
    this.formularioToken = true;
  }

  markFormGroupTouched(form: FormGroup) {
    Object.values(form.controls).forEach(control => {
      control.markAsTouched();
      if ((control as any).controls) {
        this.markFormGroupTouched(control as FormGroup);
      }
    });
  }

  onSubmit(opc, form) {
    this.spinner.show();
    if (opc === 1) {
      this.spinner.show();
      this.labelsFormulario.titulo = 'DATOS DEL CRÉDITO';
      this.stepActive.two = 'active';
      this.sectionActive = 'two';
      this.spinner.hide();
    }
    if (opc === 2) {
      if (this.NUMCREDRECOGE.value !== null) {
        this.MONTO.disable();
      }
      this.spinner.show();
      if (form.invalid) {
        console.log(form)
        this.markFormGroupTouched(this.formularioDatosCredito);
        this.spinner.hide();
        alert('Para continuar es necesario completar todos los campos requeridos.');
        return;
      }
      if(this.config.general.codeudoresSolCred == 'S'){
        this.labelsFormulario.titulo = 'DATOS CODEUDOR';
        this.stepActive.three = 'active';
        this.sectionActive = 'three';
        this.spinner.hide();
      }else{
        this.labelsFormulario.titulo = 'ADJUNTOS';
        this.stepActive.four = 'active';
        this.sectionActive = 'four';
        this.spinner.hide();
      }
    }
    if (opc === 3) {
      this.spinner.show();
      if (form.invalid) {
        this.markFormGroupTouched(this.formularioCodeudores);
        this.spinner.hide();
        alert('Para continuar es necesario completar todos los campos requeridos,');
        return;
      }
      this.labelsFormulario.titulo = 'ADJUNTOS';
      this.stepActive.four = 'active';
      this.sectionActive = 'four';
      this.spinner.hide();
    }
    if (opc === 4) {
      this.spinner.show();
      if (form.invalid) {
        this.markFormGroupTouched(this.formularioAdjuntos);
        this.spinner.hide();
        alert('Para continuar es necesario completar todos los campos requeridos..');
        return;
      }
      this.labelsFormulario.titulo = 'AUTORIZACIONES';
      this.stepActive.five = 'active';
      this.sectionActive = 'five';
      this.spinner.hide();
    }
    if (opc === 5) {
      this.spinner.show();
      if (form.invalid) {
        this.markFormGroupTouched(this.formularioAutorizaciones);
        this.spinner.hide();
        alert('Para continuar es necesario completar todos los campos requeridos...');
        return;
      }
      const date = new Date();
      const day = date.getDate();
      const monthIndex = date.getMonth();
      const year = date.getFullYear();
      const hours = new Date();

      let plazoLetras;
      if (this.formularioDatosCredito.get('CODFREC').value === 'M') {
        plazoLetras = 'Meses';
      } else {
        plazoLetras = 'Quincenas';
      }

      const data = {
        monto: this.formularioDatosCredito.get('MONTO').value,
        codlin: this.formularioDatosCredito.get('CODLINEA').value,
        coddestino: this.formularioDatosCredito.get('CODDESTINO').value,
        codasociado: this.identity.CODUNICO,
        fhacomite: year + '-' + (monthIndex + 1) + '-' + day,
        usrcrea: 21,
        hora: hours,
        plazo: this.formularioDatosCredito.get('PLAZO').value,
        adjunto1: this.formularioAdjuntos.get('DOCUPLOAD1').value,
        adjunto2: this.formularioAdjuntos.get('DOCUPLOAD2').value,
        seguro: this.formularioDatosCredito.get('SEGURO').value,
        tasa: 0,
        datosUsuario: this.identity,
        codeudor1: this.formularioCodeudores.get('DOCCODEUDOR1').value,
        codeudor2: this.formularioCodeudores.get('DOCCODEUDOR2').value,
        codeudores: this.formularioCodeudores.get('CONCODEUDOR').value,
        codfrec: this.formularioDatosCredito.get('CODFREC').value,
        recogeCreditos: this.formularioDatosCredito.get('RECOGECRED').value,
        numCredRecoge: this.formularioDatosCredito.get('NUMCREDRECOGE').value,
        datosCredRecoge: this.formularioDatosCredito.get('DATOSCREDITORECOGE').value,
        plazoLetras,
        lineaLetras: this.formularioDatosCredito.get('LINEA').value,
        datosGeneral: this.formularioDatosPersonales,
        datosSolicitud: this.formularioDatosCredito.value

      };
      this._userService.httpPost('guardarSolicitudCredito', data).subscribe(resp => {
        if (resp.status == 'success') {
          alert(resp.message);
          this.comprobrarSolicitudes();
          this.switchForm(false);
          location.reload();
        } else {
          alert(resp.message);
        }
        this.spinner.hide();
      }, error => {
        console.log(error);
        this.spinner.hide();
      });

    }
  }

  onFileChange(event, opt) {
    this.spinner.show();
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('adjunto', file);
      this._userService.httpPost('upload', formData).subscribe(resp => {
        this.spinner.hide();
        if (resp.status === 'success') {
          if (opt === 1) {
            this.formularioAdjuntos.controls.DOCUPLOAD1.setValue(resp.filename);
          } else {
            this.formularioAdjuntos.controls.DOCUPLOAD2.setValue(resp.filename);
          }
        } else {
          if (opt === 1) {
            this.formularioAdjuntos.get('ADJUNTO1').setValue('');
          } else {
            this.formularioAdjuntos.get('ADJUNTO2').setValue('');
          }
          alert(resp.message);
        }
      }, error => {
        this.spinner.hide();
        alert(JSON.stringify(error.error.message));
      });
    }
  }

  gotoUrl() {
    this._userService.httpGet('validarActualizacion/'+this.identity.CODASOCIADO).subscribe(async resp => {
      if (resp.ACTUALIZA === 1 && this.aplicaActualizaDatos) {
        alert('Antes de solicitar un crédito es necesario actualizar tus datos');
        this.router.navigateByUrl('actualizacion');
      } else {
        await this.switchForm(true);
      }
    }, error => {
      this.spinner.show();
      console.log(error);
    });
  }

  goBack(op) {
    if (op === 2) {
      this.stepActive.two = '';
      this.sectionActive = 'one';
    }
    if (op === 3) {
      this.stepActive.three = '';
      this.sectionActive = 'two';
    }
    if (op === 4) {
      if(this.config.general.codeudoresSolCred == 'S'){
        this.stepActive.four = '';
        this.sectionActive = 'three';
      }else{
        this.stepActive.three = '';
        this.sectionActive = 'two';
      }
    }
    if (op === 5) {
      this.stepActive.five = '';
      this.sectionActive = 'four';
    }
  }

  async switchForm(value) {
    this.spinner.show();
    this.showFormSolicitudes = value;
    if (value) {
      await this.getCiudades();
      await this.getDepartamentos();
      await this.getBancos();
      await this.getEntidades();
      await this.getTipoVinculo();
      await this.getCargos();
      await this.getLineasCredito();
      await this.getDestinoCred();
      await this.getFrecuencias();
      await this.getParamsAdjuntos();
      await this.getPrecargaDatos();
    }
  }

  getDepartamentos() {
    this._userService.httpGet('departamentos').subscribe(resp => {
      this.departamentos = resp;
    }, error => {
      console.log(error);
    });
  }

  getBancos() {
    this._userService.httpGet('bancos').subscribe(resp => {
      this.bancos = resp;
    }, error => {
      console.log(error);
    });
  }

  getEntidades() {
    this._userService.httpGet('entidades').subscribe(resp => {
      this.entidades = resp;
    }, error => {
      console.log(error);
    });
  }

  getTipoVinculo() {
    this._userService.httpGet('tipovinculacion').subscribe(resp => {
      this.vinculos = resp;
    }, error => {
      console.log(error);
    });
  }

  getCargos() {
    this._userService.httpGet('cargos').subscribe(resp => {
      this.cargos = resp;
    }, error => {
      console.log(error);
    });
  }

  getCiudades() {
    this._userService.httpGet('ciudades').subscribe(resp => {
      this.ciudades = resp;
      console.log(this.ciudades);
    }, error => {
      console.log(error);
    });
  }

  getPrecargaDatos() {
    this.spinner.show();
    this._userService.httpGet('precarga/'+this.identity.CODASOCIADO).subscribe(resp => {
      this.formularioDatosPersonales = resp;
      this.formularioDatosPersonales.NOMBRESREFFAMILIAR2 = ''
      /*if (this.formularioDatosPersonales.CIUDAD_EMPRESA_V2.length==4) {
        //this.formularioDatosPersonales.CIUDAD_EMPRESA_V2='0'+this.formularioDatosPersonales.CIUDAD_EMPRESA_V2;
      }*/
      console.log("city",this.formularioDatosPersonales.CIUDAD_EMPRESA_V2);
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
      console.log(error);
    });
  }

  getDestinoCred() {
    this._userService.httpGet('destinoCredito').subscribe(resp => {
      this.destinos = resp;
    }, error => {
      console.log(error);
    });
  }

  getFrecuencias() {
    this._userService.httpGet('frecuenciasCredito').subscribe(resp => {
      this.frecuencias = resp.details;
    }, error => {
      console.log(error);
    });
  }

  async comprobrarSolicitudes() {
    this.spinner.show();
    this._userService.httpGet('listarSolicitudes/'+this.identity.CODUNICO).subscribe(response => {
        this.spinner.hide();
        if (response.status == 'error') {
          alert(response.message);
        } else {
          //console.log(response.details);
          this.disabled_solicitudes = true;
          this.solicitudes = response.details;
        }
      },
      error => {
        this.spinner.hide();
        console.log(error as any);
      }
    );
  }

  listarSolicitudesCodeudor() {
    this.spinner.show();
    this._userService.httpGet('listarSolicitudesCodeudor/'+this.identity.CODUNICO).subscribe(response => {
        this.spinner.hide();
        if (status == 'error') {
          alert(response.message);
        } else {
          this.disabled_solicitudes = true;
          this.solicitudes_codeudor = response.details;
          console.log("Datos solicitudes", this.solicitudes_codeudor);
        }
      },
      error => {
        this.spinner.hide();
        console.log(error as any);
      }
    );
  }

  getLineasCredito() {
    this._userService.httpGet('lineasCredito').subscribe(resp => {
      this.lineasCredito = resp;
      console.log(this.lineasCredito)
    }, error => {
      console.log(error as any);
    });
  }

  getLineadeCreditoLetras(event) {
    const codlin = event.target.value;
    const lineadeCredito = this.lineasCredito.find(linea => linea.CODLIN == codlin);
    this.formularioDatosCredito.get('LINEA').setValue(lineadeCredito.DESCRIPCION);
  }

  getPlazosCredito(event) {
    this.spinner.show();
    const codlin = event.target.value;
    this._userService.httpGet('plazosCredito/'+codlin).subscribe(resp => {
      this.spinner.hide();
      const plazomax = resp.PLAZMAX;
      this.condicionesLineaCredito = resp.CONDICIONES;
      this.plazos = Array();
      for (let i = 1; i <= plazomax; i++) {
        this.plazos.push({
          CODPLAZO: i,
          PLAZO: i
        });
      }
      this._userService.httpGet('listarSeguroCredito/'+codlin).subscribe(resp => {
        if (resp.status === 'success') {
          this.formularioDatosCredito.get('SEGURO').setValue(resp.details);
        } else {
          this.formularioDatosCredito.get('SEGURO').setValue(0);
        }
      }, error => {
        this.spinner.hide();
        console.log(error as any);
      });
    }, error => {
      this.spinner.hide();
      console.log(error as any);
    });
  }

  openModal(datosCredito) {
    this.datosSolicitudCreditoToken = datosCredito;
  }

  realizarFirmaPagare(cb) {
    this.spinner.show();
    const datos = {
      codunico: this.identity.CODUNICO,
      numsol: this.datosSolicitudCreditoToken.NUMSOL,
      nit: this.identity.NIT,
      token: this.createFormGroup.token
    };
    this._userService.httpPost('firmarPagare', datos).subscribe(result => {
      this.spinner.hide();
      return cb(null, result);
    }, error => {
      this.spinner.hide();
      console.log(error);
    });
  }

  async generarTokenPagare() {
    this.spinner.show();
    this.respuesta.message = 'Procesando Solicitud, espera un momento por favor mientras validamos tus datos...';
    this.respuesta.form = 'true';

    this.alamacenarDatosGirador((err, datosGirador) => {

      console.log('entró aqui');
      const datosAlmacenarPagare = {
        numsol: this.datosSolicitudCreditoToken.NUMSOL,
        monto: this.datosSolicitudCreditoToken.MONTO,
        nit: this.identity.NIT,
        codasociado: this.identity.CODASOCIADO,
        codunico: this.identity.CODUNICO
      };
      if (datosGirador.status === 'success') {
        this._userService.httpPost('almacenarDatosPagare', datosAlmacenarPagare).subscribe(response => {
          this.spinner.hide();
          if (response.status === 'success') {
            const datosToken = {
              nombres: this.identity.NOMBRES + ' ' + this.identity.APELLIDOS,
              nit: this.identity.NIT,
              email: this.identity.EMAIL1,
              //email: 'esteban.boada17@gmail.com',
              numsol: this.datosSolicitudCreditoToken.NUMSOL,
              codunico: this.identity.CODUNICO,
            };
            this._userService.httpPost('generarTokenPagare', datosToken).subscribe(async resul => {
              this.spinner.hide();
              if (resul.status === 'success') {
                this.createFormGroup.token = '';
                this.tokenEnviado = true;
                this.formularioToken = true;
                this.alert.msg = resul.message;
              } else {
                this.alert.msg = resul.message;
                this.alert.type = 'danger';
              }
            }, error => {
              this.spinner.hide();
              this.alert.msg = error;
              this.alert.type = 'danger';
            });

          } else {
            this.alert.msg = response.message;
            this.alert.type = 'danger';
          }
        }, error => {
          this.alert.msg = error;
          this.alert.type = 'danger';
        });
      } else {
        this.alert.msg = err;
        this.alert.type = 'danger';
      }
    });
  }

  async generarTokenPagareCodeudor() {
    this.spinner.show();
    this.alert.msg = 'Procesando Solicitud, espera un momento por favor mientras validamos tus datos...';
    this.alert.timeout = 10000;

    const datosToken = {
      nombres: this.identity.NOMBRES + ' ' + this.identity.APELLIDOS,
      nit: this.identity.NIT,
      email: this.identity.EMAIL1,
      //email: 'esteban.boada17@gmail.com',
      numsol: this.datosSolicitudCreditoToken.NUMSOL,
      codunico: this.identity.CODUNICO,
    };
    this._userService.httpGet('generarTokenPagare/'+datosToken).subscribe(async resul => {
      this.spinner.hide();
      if (resul.status === 'success') {
        this.tokenEnviado = true;
        this.formularioToken = true;
        this.alert.msg = resul.message;
        this.createFormGroup.token = '';
      } else {
        this.alert.type = 'danger';
        this.alert.msg = resul.message;
      }
    }, error => {
      this.spinner.hide();
      this.alert.msg = error.message + ' ' + error.details;
      this.alert.type = 'danger';
      console.log(error);
    });
  }

  alamacenarDatosGirador(cb) {
    const datos = {
      codasociado: this.identity.CODASOCIADO,
      numsol: this.datosSolicitudCreditoToken.NUMSOL,
      codunico: this.identity.CODUNICO
    };

    console.log("Milton: ",datos);
    this._userService.httpPost('almacenarDatosGirador', datos).subscribe(resp => {
      console.log("miltonnn",resp);
      if (resp.status === 'success') {
        localStorage.setItem('numidentificacionDeceval', resp.details);
        return cb(null, resp);
      } else {
        return cb(resp.message);
      }
    }, error => {
      alert(JSON.stringify(error as any));
    });
  }

  async validarTokenPagare() {
    if (this.createFormGroup.token == '') {
      alert('Para continuar es necesario completar los campos');
      return;
    }

    this.spinner.show();
    this.desabilitarbtn = true;
    const datosConfirmacion = {
      numsol: this.datosSolicitudCreditoToken.NUMSOL,
      codunico: this.identity.CODUNICO,
      token: this.createFormGroup.token
    };

    this.respuesta.message = 'Procesando Solicitud, espera un momento por favor mientras validamos tus datos...';
    this.alert.msg = 'Procesando Solicitud, espera un momento por favor mientras validamos tus datos...';

    this._userService.httpPost('validarTokenPagare', datosConfirmacion).subscribe(async response => {
        console.log(response);
        if (response.status == 'success') {
          this.realizarFirmaPagare((err, resp) => {
            this.spinner.hide();
            if (resp.status == 'success') {
              this.alert.msg = resp.message;
              this.alert.type = 'success';
              this.tokenEnviado = true;
              this.formularioToken = false;
              this.exitoFirma = false;
              alert(resp.message);
            } else {
              this.alert.msg = resp.message;
              this.alert.type = 'danger';
              this.formularioToken = true;
              this.exitoFirma = true;
            }
          });
        } else {
          this.spinner.hide();
          this.alert.msg = response.message;
        }

      }, error => {
        this.spinner.hide();
        this.alert.msg = error;
        this.alert.type = 'danger';
        console.log(error);
      }
    );
  }

  validarExisteCodeudor(event, opc) {
    const nitcodeudor = event.target.value;
    if (opc === 1) {
      if ((nitcodeudor != null) && nitcodeudor === this.formularioCodeudores.get('DOCCODEUDOR2').value) {
        alert('No se puede usar el mismo codeudor en ambos campos');
        this.formularioCodeudores.get('DOCCODEUDOR1').setValue('');
      }
    }
    if (opc === 2) {
      if ((nitcodeudor != null) && nitcodeudor === this.formularioCodeudores.get('DOCCODEUDOR1').value) {
        alert('No se puede usar el mismo codeudor en ambos campos');
        this.formularioCodeudores.get('DOCCODEUDOR2').setValue('');
      }
    }
    this._userService.httpGet('validaCodeudor/'+nitcodeudor).subscribe((resp) => {
      if (resp.estado !== 1) {
        alert('El codeudor que has ingresado no existe ó no se encuentra activo');
        if (opc === 1) {
          this.formularioCodeudores.get('DOCCODEUDOR1').setValue('');
        } else {
          this.formularioCodeudores.get('DOCCODEUDOR2').setValue('');
        }
      }
    }, (error => {
      console.log(error);
    }));
  }

  swichtCodeudores(event) {
    const dato = event.target.value;
    if (dato === 'S') {
      this.tcodeudores = true;
      this.formularioCodeudores.get(`DOCCODEUDOR1`).setValidators([Validators.required, Validators.pattern('[0-9 ]{6,12}')]);
      this.formularioCodeudores.get(`DOCCODEUDOR1`).setErrors({invalid: true});
      this.formularioCodeudores.get(`DOCCODEUDOR1`).markAsDirty();

      /*this.formularioCodeudores.get(`DOCCODEUDOR2`).setValidators([Validators.required, Validators.pattern('[0-9 ]{6,12}')]);
      this.formularioCodeudores.get(`DOCCODEUDOR2`).setErrors({ invalid: true });
      this.formularioCodeudores.get(`DOCCODEUDOR2`).markAsDirty();*/
    } else {
      this.tcodeudores = false;
      this.formularioCodeudores.get(`DOCCODEUDOR1`).setErrors(null);
      this.formularioCodeudores.get(`DOCCODEUDOR1`).setValidators([]);

      this.formularioCodeudores.get(`DOCCODEUDOR2`).setErrors(null);
      this.formularioCodeudores.get(`DOCCODEUDOR2`).setValidators([]);
    }
  }

  validarRecogeCred(event, content) {
    const valor = event.target.value;
    if (valor === 'S') {
//      this.openModalRecogeCred(true);
      this.openModalRecogeCredN(content);
      this.formularioDatosCredito.get(`NUMCREDRECOGE`).setValidators([Validators.required, Validators.pattern('[0-9, ]{2,80}')]);
      this.formularioDatosCredito.get(`NUMCREDRECOGE`).setErrors({invalid: true});
      this.formularioDatosCredito.get(`NUMCREDRECOGE`).markAsDirty();
    } else {
      this.pagaresRecoger = [];
      this.datosCreditos = [];
      this.formularioDatosCredito.get('NUMCREDRECOGE').setValue('');
      this.formularioDatosCredito.get(`NUMCREDRECOGE`).setErrors(null);
      this.formularioDatosCredito.get(`NUMCREDRECOGE`).setValidators([]);
    }
  }

  validarTerminos(event, opt) {
    const valor = this.formularioAutorizaciones.get(event.target.name).value;
    if (!valor) {
      this.formularioAutorizaciones.get(event.target.name).setValidators([Validators.required]);
      this.formularioAutorizaciones.get(event.target.name).setErrors({invalid: true});
      this.formularioAutorizaciones.get(event.target.name).markAsDirty();
    } else {
      this.formularioAutorizaciones.get(event.target.name).setErrors(null);
      this.formularioAutorizaciones.get(event.target.name).setValidators([]);
    }
  }

  buildForm() {
    this.formularioDatosCredito = this.fb.group({
        CODLINEA: ['', [Validators.required]],
        LINEA: [''],
        PLAZO: ['', [Validators.required]],
        MONTO: ['', [Validators.required, Validators.pattern('[1-9][0-9]{4,8}')]],
        CODDESTINO: ['', [Validators.required]],
        CODFREC: ['', [Validators.required]],
        RECOGECRED: ['', [Validators.required]],
        NUMCREDRECOGE: [''],
        FONDOMUTUAL: ['S', [Validators.required]],
        NOMBRESREFFAMILIAR1: ['', [Validators.required, Validators.pattern('([A-Za-zñáéíóú\\s]){3,50}')]],
        DIRECCIONREFFAMILIAR1: ['', [Validators.required, Validators.pattern('([a-zA-Z0-9 ]+)')]],
        CELULARREFFAMILIAR1: ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
        CIUDADREFFAMILIAR1: ['', [Validators.required]],
        /*NOMBRESREFFAMILIAR2: ['', [Validators.required, Validators.pattern('([A-Za-zñáéíóú\\s]){3,50}')]],
        DIRECCIONREFFAMILIAR2: ['', [Validators.required, Validators.pattern('([a-zA-Z0-9 ]+)')]],
        CELULARREFFAMILIAR2: ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
        CIUDADREFFAMILIAR2: ['', [Validators.required]],
        NOMBRESREFPERSONAL1: ['', [Validators.required, Validators.pattern('([A-Za-zñáéíóú\\s]){3,50}')]],
        DIRECCIONREFPERSONAL1: ['', [Validators.required, Validators.pattern('([a-zA-Z0-9 ]+)')]],
        CELULARREFPERSONAL1: ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
        CIUDADREFPERSONAL1: ['', [Validators.required]],
        NOMBRESREFPERSONAL2: ['', [Validators.required, Validators.pattern('([A-Za-zñáéíóú\\s]){3,50}')]],
        DIRECCIONREFPERSONAL2: ['', [Validators.required, Validators.pattern('([a-zA-Z0-9 ]+)')]],
        CELULARREFPERSONAL2: ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
        CIUDADREFPERSONAL2: ['', [Validators.required]],*/
        SEGURO: [],
        DATOSCREDITORECOGE: []
      }
    );


    this.formularioCodeudores = this.fb.group({
      CONCODEUDOR: ['', [Validators.required]],
      DOCCODEUDOR1: [''],
      DOCCODEUDOR2: [''],
    });

    this.formularioAdjuntos = this.fb.group({
      ADJUNTO1: [''],
      ADJUNTO2: [''],
      DOCUPLOAD1: [''],
      DOCUPLOAD2: ['']
    });

    this.formularioAutorizaciones = this.fb.group({
      AUTORIZACION1: ['', [Validators.required]],
      AUTORIZACION2: ['', [Validators.required]],
    });
  }

  get CODFREC() {
    return this.formularioDatosCredito.get('CODFREC');
  }

  get CODDESTINO() {
    return this.formularioDatosCredito.get('CODDESTINO');
  }

  get AUTORIZACION1() {
    return this.formularioAutorizaciones.get('AUTORIZACION1');
  }

  get AUTORIZACION2() {
    return this.formularioAutorizaciones.get('AUTORIZACION2');
  }

  get ADJUNTO1() {
    return this.formularioAdjuntos.get('ADJUNTO1');
  }

  get ADJUNTO2() {
    return this.formularioAdjuntos.get('ADJUNTO2');
  }

  get CONCODEUDOR() {
    return this.formularioCodeudores.get('CONCODEUDOR');
  }

  get DOCCODEUDOR1() {
    return this.formularioCodeudores.get('DOCCODEUDOR1');
  }

  get DOCCODEUDOR2() {
    return this.formularioCodeudores.get('DOCCODEUDOR2');
  }

  get CIUDADREFPERSONAL2() {
    return this.formularioDatosCredito.get('CIUDADREFPERSONAL2');
  }

  get CELULARREFPERSONAL2() {
    return this.formularioDatosCredito.get('CELULARREFPERSONAL2');
  }

  get DIRECCIONREFPERSONAL2() {
    return this.formularioDatosCredito.get('DIRECCIONREFPERSONAL2');
  }

  get NOMBRESREFPERSONAL2() {
    return this.formularioDatosCredito.get('NOMBRESREFPERSONAL2');
  }

  get CIUDADREFPERSONAL1() {
    return this.formularioDatosCredito.get('CIUDADREFPERSONAL1');
  }

  get CELULARREFPERSONAL1() {
    return this.formularioDatosCredito.get('CELULARREFPERSONAL1');
  }

  get DIRECCIONREFPERSONAL1() {
    return this.formularioDatosCredito.get('DIRECCIONREFPERSONAL1');
  }

  get NOMBRESREFPERSONAL1() {
    return this.formularioDatosCredito.get('NOMBRESREFPERSONAL1');
  }

  get CIUDADREFFAMILIAR2() {
    return this.formularioDatosCredito.get('CIUDADREFFAMILIAR2');
  }

  get CELULARREFFAMILIAR2() {
    return this.formularioDatosCredito.get('CELULARREFFAMILIAR2');
  }

  get DIRECCIONREFFAMILIAR2() {
    return this.formularioDatosCredito.get('DIRECCIONREFFAMILIAR2');
  }

  get NOMBRESREFFAMILIAR2() {
    return this.formularioDatosCredito.get('NOMBRESREFFAMILIAR2');
  }

  get CIUDADREFFAMILIAR1() {
    return this.formularioDatosCredito.get('CIUDADREFFAMILIAR1');
  }

  get CELULARREFFAMILIAR1() {
    return this.formularioDatosCredito.get('CELULARREFFAMILIAR1');
  }

  get DIRECCIONREFFAMILIAR1() {
    return this.formularioDatosCredito.get('DIRECCIONREFFAMILIAR1');
  }

  get NOMBRESREFFAMILIAR1() {
    return this.formularioDatosCredito.get('NOMBRESREFFAMILIAR1');
  }

  get CODLINEA() {
    return this.formularioDatosCredito.get('CODLINEA');
  }

  get PLAZO() {
    return this.formularioDatosCredito.get('PLAZO');
  }

  get MONTO() {
    return this.formularioDatosCredito.get('MONTO');
  }

  get RECOGECRED() {
    return this.formularioDatosCredito.get('RECOGECRED');
  }

  get NUMCREDRECOGE() {
    return this.formularioDatosCredito.get('NUMCREDRECOGE');
  }

  get FONDOMUTUAL() {
    return this.formularioDatosCredito.get('FONDOMUTUAL');
  }

}

function secondsToString(seconds) {
  const numdays = Math.floor(seconds / 86400);
  const numhours = Math.floor((seconds % 86400) / 3600);
  const numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
  const numseconds = ((seconds % 86400) % 3600) % 60;

  return numdays + ' dias ' + numhours + ' horas ' + numminutes + ' minutos ' + numseconds + ' segundos';
}

function formatDate(date) {
  let d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }

  return [year, month, day].join('/');
}
